import { Routes, Route, Navigate } from "react-router-dom";
import Navigation from "../../components/Navigation/Navigation.js";
import Participants from "./Participants/index.js";
import Progress from "./Progress/Progress.js";
import Targets from "./Targets/index.js";

const GameStatus = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to="participants" replace />} />
        <Route path="participants" element={<Participants />} />
        <Route path="targets/*" element={<Targets />} />
        <Route path="progress/*" element={<Progress />} />
      </Routes>
    </>
  );
};
export default GameStatus;
